import PrevNextBtns from '@/components/calculators/components/PrevNextBtns';
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Checkbox, message } from 'antd';
import { Mm100Page } from '../../index';
import { Appliances, calculateTotalPower } from './appliances';
import css from './index.module.scss';
import ApplianceModal, { defaultData } from './Modal';
export default function Step3({ data, callBack }: any) {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('shared');
    const customeAppliance = data?.allAppliances && data?.allAppliances?.find((app: any) => app.key === 'custome');
    const [allAppliances, setAllApplicances] = useState(
        customeAppliance ? data?.allAppliances : data?.allAppliances?.length ? data?.allAppliances : Appliances,
    );
    const [selected, setSelected] = useState(data?.appliances || ([] as any));
    const [editItem, setEditItem] = useState({ item: null, visible: false, type: 'edit' });
    const [customeFlag, setCustomeFlag] = useState(!customeAppliance);
    const [checkedFlag, setCheckedFlag] = useState(Boolean(selected?.length));
    const [totalPower, setTotalPower] = useState(data?.totalPower ?? calculateTotalPower(allAppliances, selected));

    const handleChangeCheck = (app: any, e: any) => {
        if (e.target.checked) {
            const checkedAppliances = [...selected, app];
            !checkedFlag && setCheckedFlag(true);
            setSelected(checkedAppliances);
            const newTotalPower = calculateTotalPower(allAppliances, checkedAppliances);
            setTotalPower(newTotalPower);
            callBack({ appliances: checkedAppliances, totalPower: newTotalPower });
        } else {
            const checkedAppliances = selected.filter((item: any) => item.key !== app.key);
            setSelected(checkedAppliances);
            const newTotalPower = calculateTotalPower(allAppliances, checkedAppliances);
            setTotalPower(newTotalPower);
            callBack({ appliances: checkedAppliances, totalPower: newTotalPower });
        }
    };

    const handleEdit = (app: any, type = 'edit') => {
        setEditItem({ item: app, visible: true, type });
    };

    const handleCleanAll = () => {
        // if (selected?.length && checkedFlag) {
        callBack({ apppliances: [], totalPower: 0, allAppliances: Appliances });
        setCheckedFlag(false);
        setSelected([]);
        setTotalPower(0);
        setEditItem({ item: null, visible: false, type: 'edit' });
        setAllApplicances(Appliances);
        setCustomeFlag(true);
        // }
    };

    const onNext = () => {
        // const keys = selected.map((item: any) => item.key.replace('_', ' '))
        const keys: any = [];
        allAppliances?.map((item: any) => {
            selected?.forEach((ele: any) => {
                if (item.key === ele.key) {
                    keys.push(ele.key.replace('_', ' '));
                }
            });
        });

        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator3',
            step: 'appliance',
            product_name: 'Ecoflow Power Kits',
            option_name: keys,
            button_name: 'Next',
            consumption: `${totalPower}Kwh/day`,
        });
        callBack({
            currentStep: data.currentStep + 1,
            currentPage: Mm100Page.PowerKits,
            appliances: selected,
            allAppliances,
            totalPower,
        });
    };

    const onBack = () => {
        callBack({
            currentStep: data.currentStep - 1,
            currentPage: data?.scene === 'others' ? Mm100Page.Scenery : Mm100Page.Type,
            appliances: null,
            allAppliances: null,
            totalPower: null,
        });
    };

    const valiConfirm = (item: any) => {
        if (String(Number(item?.power)) === 'NaN' || String(Number(item?.time?.h)) === 'NaN' || String(Number(item?.time?.m)) === 'NaN') {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        if (
            Number(item?.power) <= 0 ||
            Number(item?.time?.h) < 0 ||
            Number(item?.time?.h) > 24 ||
            Number(item?.time?.m) < 0 ||
            Number(item?.time?.m) > 60 ||
            Number(item?.power) % 1 !== 0 ||
            Number(item?.time?.h) % 1 !== 0 ||
            Number(item?.time?.m) % 1 !== 0 ||
            (Number(item?.time?.h) === 24 && Number(item?.time?.m) !== 0) ||
            (Number(item?.time?.h) === 0 && Number(item?.time?.m) === 0)
        ) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        return true;
    };

    const onModalConfirm = (item: any, type: string) => {
        if (valiConfirm(item)) {
            if (type === 'edit') {
                const newAllAppliances = allAppliances?.map((app: any) => (app.key === item.key ? item : app));
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(newAllAppliances, selected);
                setTotalPower(newTotalPower);
                callBack({ allAppliances: newAllAppliances, totalPower: newTotalPower });
            }
            if (type === 'add') {
                const newSelected = [...selected, item];
                const newAllAppliances = [...allAppliances, item];
                setSelected(newSelected);
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(newAllAppliances, newSelected);
                setTotalPower(newTotalPower);
                setCustomeFlag(false);
                callBack({
                    allAppliances: newAllAppliances,
                    appliance: newSelected,
                    totalPower: newTotalPower,
                });
            }
            setEditItem({ item: null, visible: false, type: 'edit' });
        }
    };

    const onModalCancel = () => {
        setEditItem({ item: null, visible: false, type: 'edit' });
    };

    const generateDesc = (app: any) => {
        return `${app?.power}W/${Number(app?.time?.h) ? Number(app?.time?.h) + t('calculators.mm100.step3.time_h_s') : ''}${
            Number(app?.time?.h) && Number(app?.time?.m) ? ' ' : ''
        }${Number(app?.time?.m) ? app?.time?.m + t('calculators.mm100.step3.time_m_s') : ''}${t('calculators.mm100.step3.per_day')}`;
    };

    return (
        <div className={`step3 step ${css.step3}`}>
            <div className="titleBox">
                <p className="title">{t('calculators.mm100.step3.title')}</p>
                <span className="cleanAllBtn" onClick={handleCleanAll}>
                    {t('calculators.mm100.step3.clean')}
                </span>
            </div>
            <div className="appliances">
                {allAppliances?.map((app: any) => (
                    <li className={`appliance ${selected.find((item: any) => item.key === app.key) ? 'active' : ''}`} key={app.key}>
                        <div className="appIcon">
                            <Image
                                src={app?.icon}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step3.${app.i18n}`)}
                                aria-label={t(`calculators.mm100.step3.${app.i18n}`)}
                            />
                        </div>
                        <div className="appName">
                            <p className="name">{t(`calculators.mm100.step3.${app?.i18n}`)}</p>
                            {/* app?.desc */}
                            <p className="power">{generateDesc(app)}</p>
                        </div>
                        <div className="editBtn" onClick={() => handleEdit(app)}>
                            {t('calculators.mm100.step3.edit')}
                        </div>
                        <div className="checkBox">
                            <Checkbox
                                checked={selected.find((item: any) => item.key === app.key) ? true : false}
                                onChange={(e: any) => handleChangeCheck(app, e)}
                            />
                        </div>
                    </li>
                ))}
                {customeFlag && (
                    <li className="custome-appliance appliance" onClick={() => handleEdit(defaultData, 'add')}>
                        <div className="appIcon">
                            <Image
                                src="/img/calculators/mm100/appliance_custom.svg"
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step3.custome`)}
                                aria-label={t(`calculators.mm100.step3.custome`)}
                            />
                        </div>
                        <div className="appName">
                            <p className="name">{t(`calculators.mm100.step3.custome`)}</p>
                        </div>
                        <div className="plusBtn">+</div>
                    </li>
                )}
            </div>
            <div className="sum">
                <span className="desc">{t('calculators.mm100.step3.desc')}</span>
                <div className="sumTotal">
                    <span className="consumption">{t('calculators.mm100.step3.comsuption')}</span>
                    <span className="totalPower">
                        {Math.round(totalPower * 100) / 100}
                        {t('calculators.mm100.step3.unit')}
                    </span>
                </div>
            </div>
            <div className="calculatorMm100-btnsArea">
                <PrevNextBtns canNext={selected?.length && totalPower} onNext={onNext} onBack={onBack} />
            </div>
            <ApplianceModal
                config={{ visible: editItem.visible }}
                item={editItem.item}
                type={editItem.type}
                onConfirm={onModalConfirm}
                onCancel={onModalCancel}
            />
        </div>
    );
}
